import {
  BaseRequiredDialogProps,
  CanopyProvider,
  DialogDraggable,
} from '@bloomfieldrobotics/canopy';
import { DialogContent } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { setDebugCurrCollectionId } from '../debugSlice';
import { DebugInfoCollections } from './DebugInfoCollections';
export const DebugInfoDialogCollections = ({
  open: isOpen,
  onClose,
}: BaseRequiredDialogProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const { collectionId } = useParams<{ collectionId: string }>();

  // If on a collection viewer page, set the debug info to the corresponding collectionId
  useEffect(() => {
    if (location.pathname.includes('/collections/') && collectionId) {
      dispatch(setDebugCurrCollectionId(collectionId));
    }
  }, [location.pathname, collectionId]);

  return (
    <DialogDraggable
      title={t('Debug Info Collections')}
      open={isOpen}
      onClose={onClose}
    >
      <CanopyProvider>
        <DialogContent>
          <DebugInfoCollections />
        </DialogContent>
      </CanopyProvider>
    </DialogDraggable>
  );
};
